module.exports = __webpack_public_path__ + "assets/img/saules-logo-small.54938a8b.png";